module.exports = __webpack_public_path__ + "static/media/mw-logo-570.47922e0b.png";